import React from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
//import { AppHeader } from 'layout/appHeader';
//import { AppSideBar } from 'layout/appSideBar';
//import { ProductList } from 'site/product/productList';
//import { ProductEdit } from 'site/product/edit/productEdit';
//import { SearchAtdw} from 'site/atdw/searchAtdw/searchAtdw';
//import { List } from 'site/atdw/list/list';
//import { Edit } from 'site/atdw/edit/edit';
import { ProvideAuth } from 'auth';
import LoginLayoutRoute from "layout/loginLayout";
import { Login } from 'auth';
//import DashboardLayoutRoute from "layout/dashboardLayout";
import {DashboardLayoutV2} from "layout/dashboardLayoutV2";

function App() {
  return (
    <ProvideAuth>
      <Router>
      <Switch>
        <LoginLayoutRoute path="/admin/login" component={Login} />
        <Route exact path="/admin/dashboard">
          <Redirect to="/admin/atdw/list" />
        </Route>
        <Route path="/admin">
          <DashboardLayoutV2></DashboardLayoutV2>
        </Route>
        <Route path="/*">
          <Redirect to="/admin" />
        </Route>
      </Switch>
      </Router>
    </ProvideAuth>
  );
}
export default App;